<template>
    <div class="g2-review-star">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
        >
            <!-- eslint-disable max-len -->
            <defs>
                <linearGradient :id="starId">
                    <stop offset="0%" :stop-color="fillColor" />
                    <stop :offset="offset" :stop-color="fillColor" />
                    <stop :offset="offset" stop-color="white" />
                    <stop offset="100%" stop-color="white" stop-opacity="1" />
                </linearGradient>
                <path
                    id="starShape"
                    d="M14.5919 3.58361C14.8565 3.02422 15.4038 2.66922 15.9998 2.66666C16.5986 2.66922 17.1444 3.02422 17.4103 3.58361L20.3126 9.73255C20.5434 10.2171 20.9826 10.5527 21.4956 10.6311L27.9885 11.6166C28.5799 11.7083 29.0708 12.1404 29.2568 12.7341C29.4409 13.3279 29.2865 13.9815 28.8598 14.4162L24.1604 19.2025C23.7915 19.5808 23.6204 20.1243 23.7096 20.6568L24.8189 27.4151C24.9184 28.0298 24.677 28.654 24.1956 29.02C23.7072 29.386 23.0688 29.4362 22.5394 29.145L16.7331 25.9546C16.2729 25.7016 15.7293 25.7039 15.269 25.9546L9.46154 29.145C8.93217 29.4362 8.29128 29.386 7.80626 29.02C7.32492 28.6517 7.08253 28.0298 7.18326 27.4151L8.29128 20.6555C8.38147 20.1243 8.20942 19.5808 7.84033 19.2025L3.14087 14.4162C2.71222 13.9815 2.5588 13.3291 2.74384 12.7341C2.92912 12.1404 3.42076 11.7083 4.01239 11.6166L10.5051 10.6311C11.0181 10.5527 11.4572 10.2171 11.6869 9.73255L14.5919 3.58361Z"
                />
                <clipPath id="insideStarOnly">
                    <use xlink:href="#starShape" />
                </clipPath>
            </defs>
            <g>
                <use
                    xlink:href="#starShape"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    :fill="`url(#${starId})`"
                    :stroke-width="STROKE_WIDTH"
                    :stroke="fillColor"
                    clip-path="url(#insideStarOnly)"
                />
            </g>
            <!-- eslint-enable max-len -->
        </svg>
    </div>
</template>
<script lang="ts">
const STROKE_WIDTH = 4; // mupltiplied by 2 because outer part of star is clipped

export default {
    name: 'G2ReviewStar',

    props: {
        starId: {
            type: String,
            required: true,
        },
        fillPercentage: {
            type: Number,
            required: true,
        },
        fillColor: {
            type: String,
            default: '#ff492c',
        },
    },

    data: () => ({
        STROKE_WIDTH,
    }),

    computed: {
        offset() {
            return `${this.fillPercentage}%`;
        },
    },
};
</script>
